<template>
  <div class="haulage-capacity-main">
    <Gantt class="capacity-gantt" :dataFromServer="dataFromServer"/>
  </div>
</template>

<script>
import Gantt from '@/components/Gantt.vue';

export default {
  components: {
    Gantt
  },
  props: {
    dataFromServer: { type: Object, default: function() { return null } },
  },
  methods: {
  },
  async mounted() {
    this.dataFromServer = { data: [] };
    // var newData = await this.$apiCallV2(`/VehicleSchedule/GanttViewTAS?start=2020-04-07%2000:00&end=2020-04-07%2023:59`);
    // this.dataFromServer = newData.data;
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.haulage-capacity-main {
  padding: 10px 45px;
  width: 100%;
  background-color: yellow;
}

.capacity-gantt {
  height: 100%;
  width: 100%;
}
</style>